const styles = (theme) => ({
  root: {
    position: 'fixed',
    inset: 0,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(4),
    backgroundColor: theme.palette.background.default,
    boxSizing: 'border-box',
  },
  content: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'auto',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    maxWidth: 520,
    width: '100%',
    padding: theme.spacing(6, 5),
    borderRadius: theme.shape.borderRadius * 2,
    boxShadow: theme.shadows[3],
    backgroundColor: theme.palette.background.paper,
  },
  badge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 96,
    height: 96,
    borderRadius: '50%',
    backgroundColor: theme.palette.statusLabel.error.secondary,
  },
  icon: {
    fontSize: 56,
    color: theme.palette.statusLabel.error.primary,
  },
  title: {
    marginTop: theme.spacing(3),
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  subtitle: {
    marginTop: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  errorCodeBox: {
    marginTop: theme.spacing(4),
    width: '100%',
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.paper.border}`,
    backgroundColor: theme.palette.code.background,
  },
  errorCodeLabel: {
    display: 'block',
    color: theme.palette.text.secondary,
  },
  errorCodeValue: {
    marginTop: theme.spacing(0.5),
    fontFamily: 'monospace',
    wordBreak: 'break-all',
    userSelect: 'all',
    color: theme.palette.text.primary,
  },
  actions: {
    marginTop: theme.spacing(5),
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column-reverse',
      width: '100%',
    },
  },
  copyButton: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  footer: {
    flexShrink: 0,
    marginTop: theme.spacing(3),
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(0.5, 2.5),
  },
  footerItem: {
    color: theme.palette.custom.disabled,
    wordBreak: 'break-all',
  },
  footerLabel: {
    color: theme.palette.custom.dark,
  },
})

export default styles
